import React from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import "./BookExpertsShare.css";
import Experts from "../../Components/HeroSection/assets/Experts.png";
import { Link } from "react-router-dom";

const BookExpertsShare = () => {
  return (
    <div className="card card-one-1 margin refund-policy-wrapper">
      <Navbar />
      <div className="refund-static-content">
        
        {/* Blog Heading */}
        <div className="static-header">
          <h1 className="container">
            UpskillMeet: Book Experts, Build Skills, and Share Your Work
          </h1>
        </div>

        {/* Blog Content */}
        <div className="container mt-4 blog-detail-wrapper">
          <img
            src={Experts}
            alt="UpskillMeet: Book Experts, Share Work, Build Skills"
            className="blog-detail-image"
          />

          <p className="blog-meta">
            <strong>Meta Title:</strong> UpskillMeet: Book Experts, Build Skills, and Share Your Work
            <br />
            <strong>Meta Description:</strong> UpskillMeet lets you book expert sessions, grow your skills, and showcase your knowledge through posts. Learn how to get started, build trust, and grow.
          </p>

          <div className="blog-detail-content">
            <p>
              UpskillMeet is a platform designed for people who want to grow , whether by learning something new or by sharing what they know.  
              You can book sessions to learn, solve problems, or get advice. You can also offer your own services and help others in your area of expertise.
            </p>
            <p>
              There are no fixed roles. A user can be a learner in one session and a mentor in the next.  
              But UpskillMeet isn’t just about sessions—it’s about building your identity, sharing your work, and being part of a space that values discipline, clarity, and trust.
            </p>
            <p>
              It’s more than a marketplace. It’s a <strong>skill marketplace</strong> where people don’t just buy or sell time but grow their credibility and presence through action.  
              <strong>Create your profile now.</strong>
            </p>

            <h2>Use the Post Section for Personal Branding</h2>
            <p>
              Your profile tells people where you’ve been. Your posts show them where you’re going.  
              The post section on UpskillMeet is your personal bulletin board—free, easy to update, and powerful for shaping your brand.
            </p>
            <ul>
              <li>Share useful insights from your field</li>
              <li>Highlight success stories from past sessions</li>
              <li>Offer practical advice or tips that solve real problems</li>
            </ul>
            <p>
              Posts don’t need to be long. Even a few lines can build trust over time.  
              And with no comment section, your posts remain clean, visible, and free of spam.
            </p>

            <h2>Stay Disciplined with Sessions</h2>
            <p>
              Once a session is booked, treat it like a professional commitment.  
              For both explorers and experts:
            </p>
            <ul>
              <li>Be on time for your session</li>
              <li>Use the Google Meet link provided</li>
              <li>Exchange the correct Start and End OTPs</li>
              <li>Leave or collect feedback after sessions</li>
            </ul>
            <p>
              Consistency, preparation, and respect create repeat bookings and lasting relationships.
            </p>

            <h2>Use Queries Before Booking</h2>
            <p>
              Queries clarify needs before booking.  
              Explorers can explain what they want, and experts can confirm if they’re the right fit.
            </p>
            <p>
              <strong>How to raise a query:</strong>
            </p>
            <ol>
              <li>Visit the expert’s profile</li>
              <li>Click on “Raise a Query”</li>
              <li>Add your topic, question, or need</li>
              <li>Wait for the expert to accept</li>
            </ol>

            <h2>Build a Profile That Converts</h2>
            <p>
              Your profile is more than a resume . It’s your storefront.  
              Complete every section: Info, experience, SME topics, and services.
            </p>
            <p>
              To offer services, you’ll need a <strong>premium plan</strong>, which unlocks:
            </p>
            <ul>
              <li>Listing and managing services</li>
              <li>Being visible in search results</li>
              <li>Receiving bookings</li>
            </ul>

            <h2>Respect the Platform and Community</h2>
            <p>
              UpskillMeet is built on trust, professionalism, and learning.  
              Avoid spam, product pitches, or misusing OTP/feedback features.  
              Instead:
            </p>
            <ul>
              <li>Share meaningful posts</li>
              <li>Book and attend sessions with commitment</li>
              <li>Give constructive feedback</li>
            </ul>

            <h2>Final Thought</h2>
            <p>
              UpskillMeet works best when you use it with intention.  
              Grow by sharing, learning, and showing up consistently.  
              This is a <strong>skill marketplace</strong>. And you are a <strong>skillfluencer</strong>.  
            </p>
            <p>
              <strong>Show up. Stay consistent. Let your work speak for you.</strong>
            </p>

            <h2>FAQ</h2>
            <p><strong>Do I need a premium plan to post?</strong> No. Posting is free. Premium is only needed for services and bookings.</p>
            <p><strong>Can I be both an expert and a learner?</strong> Yes. You can switch roles anytime.</p>
            <p><strong>How do people discover my profile?</strong> Through search, posts, and service listings. Active posting increases visibility.</p>
            <p><strong>Why is there no comment section on posts?</strong> To prevent spam and negativity. Posts stay focused and clean.</p>

            <p>
              <Link to="/signup-options" className="join-link">Ready to grow? Create your profile now.</Link>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BookExpertsShare;
